import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-list-header-expense',
  templateUrl: './list-header-expense.component.html',
  styleUrls: ['./list-header-expense.component.scss'],
  standalone: false
})
export class ListHeaderExpenseComponent {
  @Input() title: string = '';
  @Input() cost: number = 0;
  @Input() percentage: number = 0;
  @Input() statusPercentage: string = 'success';
}
